import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77f0eda3")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["home-wrapper", [(_ctx.currentIndex !== 0 && _ctx.currentIndex !== 6) && 'has-padding']],
    style: {'backgroundColor': _ctx.componentNames[_ctx.currentIndex].color},
    onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.touchstart && _ctx.touchstart(...args))),
    onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchmove && _ctx.touchmove(...args))),
    onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchend && _ctx.touchend(...args)))
  }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentNames[_ctx.currentIndex].name), { canChange: _ctx.canChange }, null, 8, ["canChange"]))
      ]),
      _: 1
    })
  ], 38))
})